import { playVo } from './audio';

export default class HeaderLogosVo {
  constructor() {
    this.pbslogo = document.getElementById('pbs-logo') || false;
    this.cclogo = document.getElementById('cc-logo') || false;

    this.triggerVo = this.triggerVo.bind(this);

    this.addEvents();
  }

  addEvents() {
    this.pbslogo.addEventListener('mouseover', (e) => {
      this.triggerVo(`vo_pbs`);
    });

    this.cclogo.addEventListener('mouseover', (e) => {
      this.triggerVo(`vo_home`);
    });
  }

  triggerVo(id) {
    playVo(id);
  }
}
